import teaConst from 'Src/const/tea.js'

export default {
  methods: {
    cancelModal (level, type, from) {
      window.promotionTeaEvent(
        'promotion_index_cancel',
        () => {
          return {
            level: level ? teaConst.promotion.level[level] : level,
            for: teaConst.modalType[type],
            from: teaConst.promotion.actionFrom[from]
          }
        },
        teaConst.type.event
      )
    },
    okModal (level, type, from) {
      window.promotionTeaEvent(
        'promotion_index_confirm',
        () => {
          return {
            level: teaConst.promotion.level[level],
            for: teaConst.modalType[type],
            from: teaConst.promotion.actionFrom[from]
          }
        },
        teaConst.type.event
      )
    }
  }
}
